import { useFetch } from "../../hooks/useFetch";
import LoadSimple from "../LoadSimple";
import Modal from "react-modal";
import ModalDeleteCis from "./ModalDeleteCis";
import { useState, useEffect } from "react";
import ModalCisAfecta from "./ModalCisAfecta";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
import Action from "../Action";
import PruebaSSH from "./PruebaSSH";
const pingModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      background: '#363636',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'30%',
      height:'20%',
      padding:'20px'
    },
  };
  const configModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      background: '#363636',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'50%',
      height:'40%',
      padding:'20px'
    },
  };
const CredentialsSSH = ({
    buscar_cis_history,
    handleChangEdit,
    cisSelected,
    server,
    languaje,
    handleShowPopup,
    mode
}) => {
    const [pingModalOpen, setPingModalOpen] =useState(false);
    
  function openPingModal() {
    setPingModalOpen(true);
  }

  function closePingModal() {
    setPingModalOpen(false);
  }
  const [configModalOpen, setConfigModalOpen] =useState(false);
    
  function openConfigModal() {
    setConfigModalOpen(true);
  }

  function closeConfigModal() {
    setConfigModalOpen(false);
  }
const [credentials,setCredentials]=useState({
    hostid: cisSelected.hostid,
    user: "string",
    pass_: "string"
  })
  const [dataSoft,setDataSoft]=useState({
    data: [],
    loading: true,
    error: null,
  })
  useEffect(()=>{
    search_softwares()
  },[])
  const search_softwares = () => {
    // setLoadingCis(true)
    setDataSoft({
      data: dataSoft.data,
      loading: true,
      error: dataSoft.error,
    });
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/getCredentialsByHostId/" +
            cisSelected.hostid,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setCredentials((prevState)=>{
            return {
                ...prevState,
                ['user']:data1.data.user
            }
            
        })
          setCredentials((prevState)=>{
              return {
                  ...prevState,
                  ['pass_']:data1.data.pass
              }
              
          })
          setDataSoft({
            data: data1,
            loading: false,
            error: dataSoft.error,
          });
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
 
  
  const [loading,setLoading]=useState(false)
  const Guardar=()=>{
    const data={
      "hostid": cisSelected.hostid,
      "user": credentials.user,
      "pass_": credentials.pass_
    }
    setLoading(true)
    const fetchDataPost = async () => {
      
   try {
     // console.log(localStorage.getItem('access_token'))
     const response = await fetch(server.url+'/api/v1/cassia/credentials', {
       method: 'POST',  
       headers: {
           'Content-Type': 'application/json',
           Authorization: `Bearer ${localStorage.getItem('access_token')}`,
         },
       body: JSON.stringify(data),
     });
     if (response.ok) {
       
       const data1 = await response.json();
       setLoading(false)
       handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['regEditCorr'])),'Credenciales Actualizadas', true)
       search_softwares()
       closeConfigModal()
     } else {
       const data1 = await response.json();
         handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
         
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
          
      setLoading(false)
        // Manejo de errores
        
        console.error(error);
      }
    };

    fetchDataPost();
  }
  const handleChange=(e)=>{
    const {name,value}=e.target

    setCredentials((prevState)=>{
        return {
            ...prevState,
            [name]:value
        }
        
    })
  }
// not_installed
const {user,pass_}=credentials
  return (
    <>
        <div className="cont-app-list">
            <div className="compact-app-list">
            {
                        (dataSoft.loading)?<LoadSimple/>:
                <div className="cont-form-ssh">
                   
                        <div className="form-GS-box">
                        <div className="user-box-GS" style={{height:'20%'}}>
                            <input required name="user" style={{background: "rgba(221, 221, 221, 0.33)"}}  placeholder='Ingresa un usuario' type="text" value={user}
                                onChange={handleChange} disabled  />
                                <label className='label-GS active ' style={{top: '-15%'}}>User</label>
                                        
                        </div>
                        <div className="user-box-GS" style={{height:'20%'}}>
                            <input required name="pass_"  style={{background: "rgba(221, 221, 221, 0.33)"}} placeholder='Ingresa una contraseña' type="text" value={pass_}
                                onChange={handleChange} disabled />
                                <label className='label-GS active ' style={{top: '-15%'}}>Password</label>
                                        
                        </div>
                        <div className="user-box-GS" style={{height:'20%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['ConfigCredentials'])}  action={()=>{openConfigModal()}}/>
                                            <Action disabled={false} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['pruevaSsh'])}  action={()=>{openPingModal()}}/>
                                            </>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                    </div>
                    
                </div>
                                }
            </div>
        </div>
        <Modal
          isOpen={pingModalOpen}
          // onAfterOpen={afterOpenExeption}
          onRequestClose={closePingModal}
          style={pingModalStyles}
          contentLabel="Example Modal2"
          // shouldCloseOnOverlayClick={false}
          >
            <PruebaSSH
             cisSelected={cisSelected}
             server={server}
             languaje={languaje}
             handleShowPopup={handleShowPopup}
             mode={mode}
             closePingModal={closePingModal}
             credentials={credentials}
            />
            {/* <PingModal actionSelected={actionSelected} server={server}isOpen={pingModalOpen} data={data} statusPing={statusPing} closePingModal={closePingModal}></PingModal> */}
        </Modal>
        <Modal
          isOpen={configModalOpen}
          // onAfterOpen={afterOpenExeption}
          onRequestClose={closeConfigModal}
          style={configModalStyles}
          contentLabel="Example Modal2"
          // shouldCloseOnOverlayClick={false}
          >
            <div className="modal-user-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {'CONFIGURAR CREDENCIALES'}
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                
                <div className="form-GS-box">
                        <div className="user-box-GS" style={{height:'33%'}}>
                            <input required name="user"  placeholder='Ingresa un usuario' type="text" value={user}
                                onChange={handleChange}   />
                                <label className='label-GS active ' style={{top: '-15%'}}>User</label>
                                        
                        </div>
                        <div className="user-box-GS" style={{height:'33%'}}>
                            <input required name="pass_"  placeholder='Ingresa una contraseña' type="text" value={pass_}
                                onChange={handleChange}  />
                                <label className='label-GS active ' style={{top: '-15%'}}>Password</label>
                                        
                        </div>
                        <div className="user-box-GS" style={{height:'33%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={()=>{closeConfigModal()}}/>
                                            <Action disabled={false} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={()=>{Guardar()}}/>
                                            </>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                    </div>
                </div>
                </div>
        </div>
          </Modal>
    </>
      
  );
};

export default CredentialsSSH;
